// extracted by mini-css-extract-plugin
export default {"page":"MeterMan_page__IDpDg","frame":"MeterMan_frame__wAd+7"};